/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import EditIcon from '@rsuite/icons/Edit';
import TrashIcon from '@rsuite/icons/Trash';

import { Table, IconButton, Divider, ButtonToolbar } from 'rsuite';
import { Block, CheckOutline } from '@rsuite/icons';
import {fundo, fonte} from './CelulaStatusFormatada';
import theme from '../../../../../styles/theme';

const { Cell } = Table;

function CelulaAlteracao({ rowData, isRegistro, criacao, setRegistro, setExibirAlteracoes, ...props }) {
  return (
    <Cell {...props} style={{
      background: fundo(rowData, isRegistro),
      color: fonte(rowData, isRegistro),
      display: 'flex',
      alignItems: 'center',
      marginTop: criacao ? '-15px' : '0px'
      }}>
        <IconButton
          disabled={!rowData.alteracoes}
          style={{
            color: '#fff',
            // backgroundColor: rowData.alteracoes
            //   ? theme.darkGreen
            //   : theme.lightGray,
            backgroundColor: 'transparent',
          }}
          onClick={() => {
            setRegistro(rowData);
            setExibirAlteracoes(true);
          }}
          color="red"
          // icon={<TrashIcon />}
          icon={rowData.alteracoes ? <CheckOutline style={{ color: theme.darkGreen }} /> : <Block style={{ color: theme.lightGray }} />}
        />
    </Cell>
  );
}

CelulaAlteracao.propTypes = {
  // rowData: PropTypes.objectOf,
  dataKey: PropTypes.string.isRequired,
};

CelulaAlteracao.defaultProps = {
  // rowData: {},
};

export default CelulaAlteracao;
